import { render } from "./ApiDocBadge.vue?vue&type=template&id=62b361f0"
import script from "./ApiDocBadge.vue?vue&type=script&lang=js"
export * from "./ApiDocBadge.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__